// components/Contact/Contact.jsx
import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [errors, setErrors] = useState({});

  // Configuración de EmailJS - REEMPLAZA CON TUS DATOS REALES
  const EMAILJS_CONFIG = {
    SERVICE_ID: 'service_g8khvph', // Tu Service ID de EmailJS
    TEMPLATE_ID: 'template_75b4aql', // Tu Template ID de EmailJS
    PUBLIC_KEY: 'eH6ORk9wA6OLNymhs' // Tu Public Key de EmailJS
  };

  // Inicializar EmailJS
  useEffect(() => {
    emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    
    // Limpiar error del campo cuando el usuario comience a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    // Validar nombre
    if (!formData.nombre.trim()) {
      newErrors.nombre = 'El nombre es obligatorio';
    } else if (formData.nombre.trim().length < 2) {
      newErrors.nombre = 'El nombre debe tener al menos 2 caracteres';
    }
    
    // Validar email
    if (!formData.email.trim()) {
      newErrors.email = 'El email es obligatorio';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = 'Por favor, ingresa un email válido';
      }
    }
    
    // Validar teléfono (opcional pero si se llena debe ser válido)
    if (formData.telefono.trim()) {
      const phoneRegex = /^[\+]?[0-9\s\-\(\)]{8,}$/;
      if (!phoneRegex.test(formData.telefono.trim())) {
        newErrors.telefono = 'Por favor, ingresa un teléfono válido';
      }
    }
    
    // Validar mensaje
    if (!formData.mensaje.trim()) {
      newErrors.mensaje = 'El mensaje es obligatorio';
    } else if (formData.mensaje.trim().length < 10) {
      newErrors.mensaje = 'El mensaje debe tener al menos 10 caracteres';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      setSubmitStatus('validation-error');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus('');
    
    try {
      // Preparar datos para EmailJS
      const templateParams = {
        from_name: formData.nombre,
        from_email: formData.email,
        phone: formData.telefono || 'No proporcionado',
        message: formData.mensaje,
        to_name: 'Alambrados Profesionales', // Tu nombre/empresa
        reply_to: formData.email,
        // Agregar timestamp
        sent_at: new Date().toLocaleString('es-AR', {
          timeZone: 'America/Argentina/Buenos_Aires',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      };

      // Enviar email usando EmailJS
      await emailjs.send(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        templateParams,
        EMAILJS_CONFIG.PUBLIC_KEY
      );
      
      setSubmitStatus('success');
      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        mensaje: ''
      });
      
      // Auto-limpiar mensaje de éxito después de 10 segundos
      setTimeout(() => {
        setSubmitStatus('');
      }, 10000);
      
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
      setSubmitStatus('error');
      
      // Auto-limpiar mensaje de error después de 8 segundos
      setTimeout(() => {
        setSubmitStatus('');
      }, 8000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePhoneCall = () => {
    window.location.href = 'tel:+5493541613151';
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola! Me interesa conocer más sobre sus servicios de alambrados.');
    window.open(`https://wa.me/5493541613151?text=${message}`, '_blank');
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:info@alambradosprofesionales.com?subject=Consulta%20sobre%20servicios';
  };

  const handleLocationClick = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=Av.+Ramón+J.+Cárcano+1175,+Villa+Carlos+Paz,+Córdoba', '_blank');
  };

  return (
    <section id="contacto" className="services-all-options">
      <div className="contact-header">
        <h2>CONTACTANOS</h2>
        <p className="contact-subtitle">
          Estamos aquí para ayudarte con todos tus proyectos de alambrados y cerramientos
        </p>
      </div>

      <div className="contact-grid">
        {/* Información de contacto compacta */}
        <div className="contact-info">
          <h3>Información de Contacto</h3>
          
          <div className="contact-item clickable" onClick={handlePhoneCall}>
            <i className="fas fa-phone"></i>
            <div>
              <strong>Teléfono:</strong> 
              <span className="contact-value phone-number">03541-420624</span>
              <span className="click-hint">Clic para llamar</span>
            </div>
          </div>
          
          <div className="contact-item clickable" onClick={handleWhatsApp}>
            <i className="fab fa-whatsapp"></i>
            <div>
              <strong>WhatsApp:</strong> 
              <span className="contact-value phone-number">+54 9 3541 613151</span>
              <span className="click-hint">Clic para chatear</span>
            </div>
          </div>

          <div className="contact-item">
            <i className="fas fa-envelope"></i>
            <div>
              <strong>Email:</strong> 
              <span className="contact-value">dbalambrados@gmail.com</span>
            </div>
          </div>
          
          <div className="contact-item">
            <i className="fas fa-map-marker-alt"></i>
            <div>
              <strong>Dirección:</strong> 
              <span className="contact-value">
                Av. Ramón J. Cárcano 1175<br />
                Villa Carlos Paz, Córdoba
              </span>
            </div>
          </div>
          
          <div className="contact-item">
            <i className="fas fa-clock"></i>
            <div>
              <strong>Horarios:</strong> 
              <span className="contact-value phone-number">
                <strong>L-V:</strong> 9:00-12:30 | 16:30-19:30<br />
                <strong>Sáb:</strong> 9:00-12:30 | <strong>Dom:</strong> Cerrado
              </span>
            </div>
          </div>

          <div className="contact-social">
            <h4>Seguinos:</h4>
            <div className="social-content">
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=61578016679920" className="social-link facebook" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://www.instagram.com/dbalambrados" className="social-link instagram" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              </div>
              <div className="social-text">
                <span className="social-handle">@dbalambrados</span>
              </div>
            </div>
          </div>
        </div>

        {/* Formulario de contacto */}
        <div className="contact-form">
          <h3>Envíanos un Mensaje</h3>
          <p className="form-subtitle">
            Completa el formulario y nos pondremos en contacto contigo lo antes posible
          </p>

          <form onSubmit={handleSubmit} noValidate autoComplete="off">
            <div className="form-group">
              <label htmlFor="nombre">
                Nombre completo <span className="required">*</span>
              </label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleInputChange}
                placeholder="Tu nombre completo"
                className={errors.nombre ? 'error' : ''}
                autoComplete="off"
                required
              />
              {errors.nombre && <span className="error-message">{errors.nombre}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="telefono">Teléfono</label>
              <input
                type="tel"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleInputChange}
                placeholder="Ej: +54 9 11 1234 5678"
                className={errors.telefono ? 'error' : ''}
                autoComplete="off"
              />
              {errors.telefono && <span className="error-message">{errors.telefono}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="email">
                Email <span className="required">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="tu@email.com"
                className={errors.email ? 'error' : ''}
                autoComplete="off"
                required
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="mensaje">
                Mensaje <span className="required">*</span>
              </label>
              <textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleInputChange}
                
                rows="5"
                className={errors.mensaje ? 'error' : ''}
                required
              ></textarea>
              {errors.mensaje && <span className="error-message">{errors.mensaje}</span>}
            </div>

            <button 
              type="submit" 
              className={`submit-btn ${isSubmitting ? 'submitting' : ''} ${submitStatus}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Enviando mensaje...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Enviar Mensaje
                </>
              )}
            </button>

            {submitStatus === 'success' && (
              <div className="form-message success">
                <i className="fas fa-check-circle"></i>
                <div>
                  <strong>¡Mensaje enviado correctamente!</strong>
                  <p>Gracias por contactarnos. Te responderemos en las próximas horas.</p>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="form-message error">
                <i className="fas fa-exclamation-circle"></i>
                <div>
                  <strong>Error al enviar el mensaje</strong>
                  <p>Por favor, inténtalo de nuevo o contáctanos directamente por WhatsApp.</p>
                </div>
              </div>
            )}

            {submitStatus === 'validation-error' && (
              <div className="form-message warning">
                <i className="fas fa-exclamation-triangle"></i>
                <div>
                  <strong>Por favor, corrige los errores</strong>
                  <p>Revisa los campos marcados en rojo.</p>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;